export const EntityChangeState = {


  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  WAIT_CONTESTATION:'WAIT_CONTESTATION',
  ANALYZE_CONTESTATION:'ANALYZE_CONTESTATION',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  ANNULLED: 'ANNULLED',

  values: () => {
    return ['DRAFT', 'SUBMITTED','WAIT_CONTESTATION','ANALYZE_CONTESTATION', 'APPROVED', 'REJECTED', 'ANNULLED'];
  },

  finalStates: () => {
    return ['APPROVED', 'REJECTED'];
  }


};
